import React, { useState } from "react";
import { Spin, Table } from "antd";
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid,
  Tooltip, ResponsiveContainer
} from "recharts";

/* =================================================
   QSR REPORT PAGE
================================================= */

const QSRReport = ({ config }) => {

  const [loading] = useState(false);

  const [data] = useState({
    tableUsageTrend: [
      { time: "10 AM", count: 10 },
      { time: "11 AM", count: 18 },
      { time: "12 PM", count: 25 }
    ],
    mobileUsageTrend: [
      { time: "10 AM", count: 2 },
      { time: "11 AM", count: 5 },
      { time: "12 PM", count: 7 }
    ],
    occupancyHistory: [
      { time: "Mon", count: 60 },
      { time: "Tue", count: 75 },
      { time: "Wed", count: 80 }
    ]
  });

  /* ---------- SAFETY ---------- */
  if (!config || !config.rows) {
    return (
      <div className="text-center text-gray-400 mt-10">
        No Report Config Found
      </div>
    );
  }

  /* ---------- GRAPH ---------- */
  const GraphCard = ({ title, graphData }) => (
    <div className="bg-white rounded-2xl p-6 shadow border">
      <h3 className="font-semibold mb-4">{title}</h3>

      <ResponsiveContainer width="100%" height={250}>
        <AreaChart data={graphData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="time" />
          <YAxis />
          <Tooltip />
          <Area
            type="monotone"
            dataKey="count"
            stroke="#6366f1"
            fill="#6366f1"
            fillOpacity={0.4}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );

  /* ---------- TABLE ---------- */
  const IncidentTable = () => (
    <div className="bg-white rounded-2xl p-6 shadow border">
      <h3 className="font-semibold mb-4">Incident Report</h3>

      <Table
        columns={[
          { title: "Type", dataIndex: "type" },
          { title: "Time", dataIndex: "time" },
          { title: "Camera", dataIndex: "camera" },
          { title: "Severity", dataIndex: "severity" }
        ]}
        dataSource={[
          {
            key: 1,
            type: "Mobile Usage",
            time: "10:30 AM",
            camera: "CAM-02",
            severity: "Medium"
          }
        ]}
      />
    </div>
  );

  /* ---------- WIDGETS ---------- */
  const WIDGETS = {
    "Trend Analysis": () => (
      <GraphCard title="Trend Analysis" graphData={data.tableUsageTrend} />
    ),
    "Table Usage Trend": () => (
      <GraphCard title="Table Usage Trend" graphData={data.tableUsageTrend} />
    ),
    "Mobile Usage Trend": () => (
      <GraphCard title="Mobile Usage Trend" graphData={data.mobileUsageTrend} />
    ),
    "Occupancy History": () => (
      <GraphCard title="Occupancy History" graphData={data.occupancyHistory} />
    ),
    "Incident Table": () => <IncidentTable />
  };

  /* ---------- RENDER ---------- */
  return (
    <div className="max-w-7xl mx-auto">

      {config.rows.map((row, rowIdx) => (
        <div
          key={rowIdx}
          style={{
            display: "grid",
            gridTemplateColumns: `repeat(${row.cards.length}, 1fr)`
          }}
          className="gap-6 mb-6"
        >
          {row.cards.map((card, idx) => {
            const Widget = WIDGETS[card.name];

            if (!Widget) {
              console.warn("Missing widget:", card.name);
              return (
                <div key={idx} className="text-red-500">
                  Missing: {card.name}
                </div>
              );
            }

            return (
              <div key={idx}>
                <Widget />
              </div>
            );
          })}
        </div>
      ))}

    </div>
  );
};

export default QSRReport;